import React from 'react';
import CapitalAutoCollectedBanner from '@di-shared/features/capital/CapitalAutoCollectedBanner';
import CapitalContents from '@di-shared/features/capital/CapitalContents';

export interface FinanceBetaContentsProps {
  vin: string;
}

function FinanceBetaContents({vin}: FinanceBetaContentsProps): JSX.Element {
  return (
    <div className="tab_content car_maintenance">
      <CapitalAutoCollectedBanner />
      <CapitalContents
        vin={vin}
        isProduction={false}
      />
    </div>
  );
}

export default FinanceBetaContents;
